import Api from '@/services/Index';

const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/student/club/votes/vote-result/' + id);
}

export default {
    get,
}
